import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Form, Table, Button, Modal, InputGroup } from 'react-bootstrap';
import { DatatableWrapper, TableHeader, TableBody, Pagination, PaginationOptions } from "react-bs-datatable";
import HRMSApi from '../../api/HRMSApi';
import AssignTeamModal from './AssignTeamModal';

const ManageTeam = () => {
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [showAddProjectModal, setShowAddProjectModal] = useState(false);
    const [assignProject, setAssignProject] = useState(false);
    const [addProject, setAddProject] = useState(false);
    const [projectForm, setProjectForm] = useState({
        projectName: "",
        members: []
    });
    const [reloadComponent, setReloadComponent] = useState(false);

    const [selectedProjects, setSelectedProjects] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [userDetails, setUserDetails] = useState();
    const [projectList, setProjectList] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [myTeamBody, setMyTeamBody] = useState([]);
    const [assignTeamBody, setAssignTeamBody] = useState([]);

    const [searchMyProjects, setSearchMyProjects] = useState("");
    const [searchMyTeam, setSearchMyTeam] = useState("");

    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const labels = { beforeSelect: " " }
    const fetchUserDetails = async () => {
        let userDetails = await HRMSApi.getContactRecordByEmail();
        setAssignProject(userDetails.records.Assign_Project__c);
        setAddProject(userDetails.records.Add_Project__c);
        if (userDetails.success) {
            setUserDetails(userDetails);
        }
        setUserDetails([]);
    }

    useEffect(() => {
        fetchTeamData();
        fetchUserDetails();
    }, [reloadComponent]);


    const fetchTeamData = async () => {
        try {
            setLoading(true);

            const myProjectsRes = await HRMSApi.getMyProjects();
            if (myProjectsRes.success && Array.isArray(myProjectsRes.records.myProjects)) {
                const formatted = myProjectsRes.records.myProjects.map((item, index) => ({
                    srNo: index + 1,
                    projectName: item.projectName,
                    reportingPerson: item.reportingPerson,
                    active: item.active ? "Yes" : "No"
                }));
                setMyTeamBody(formatted);


                setProjectList(
                    myProjectsRes.records.myProjects.map(p => ({
                        label: p.projectName,
                        value: p.projectName
                    }))
                );
            }

            const myTeamRes = await HRMSApi.getMyTeam();
            if (myTeamRes.success && Array.isArray(myTeamRes.records.myTeam)) {
                const formatted = myTeamRes.records.myTeam.map((item, index) => ({
                    srNo: index + 1,
                    projectName: item.projectName,
                    employeeName: item.employeeName,
                    active: item.employeeActive ? "Yes" : "No"
                }));
                setAssignTeamBody(formatted);
            }

            const sampleUsers = [
                { label: "John Doe", email: "john@abc.com", profileURL: "" },
                { label: "Sarah Lee", email: "sarah@xyz.com", profileURL: "" },
                { label: "Emma Wilson", email: "emma@xyz.com", profileURL: "" }
            ];

            setUsersList(sampleUsers);

            setLoading(false);
        } catch (err) {
            console.error("Error loading ManageTeam data:", err);
            setLoading(false);
        }
    };


    const handleOpenAssignModal = () => setShowModal(true);

    const handleUserSelection = (selected) => {
        setSelectedUsers(selected);
    };

    const handleAssignTeam = () => {

        setShowAssignModal(false);
        setSelectedProjects([]);
        setSelectedUsers([]);
    };

    const handleClose = () => setShowAddProjectModal(false);

    const onChangeForm = (e) => {
        const { name, value } = e.target;
        setProjectForm({ ...projectForm, [name]: value });
    };

    const onMembersSelect = (e) => {
        const selected = Array.from(e.target.selectedOptions, option => option.value);
        setProjectForm({ ...projectForm, members: selected });
    };

    const handleSaveProject = () => {
        setShowAddProjectModal(false);
        setProjectForm({ projectName: "", members: [] });
    };

    const myTeamHeader = [
        { title: "Sr No", prop: "srNo", isFilterable: true, isSortable: true },
        { title: "Project Name", prop: "projectName", sortable: true, isFilterable: true, isSortable: true },
        { title: "Reporting Person", prop: "reportingPerson", sortable: true, isFilterable: true, isSortable: true },
        { title: "Active", prop: "active", sortable: true, isFilterable: true, isSortable: true }
    ];

    const assignTeamHeader = [
        { title: "Sr No", prop: "srNo", isFilterable: true, isSortable: true },
        { title: "Project Name", prop: "projectName", sortable: true, isFilterable: true, isSortable: true },
        { title: "Employee Name", prop: "employeeName", sortable: true, isFilterable: true, isSortable: true },
        { title: "Active", prop: "active", sortable: true, isFilterable: true, isSortable: true }
    ];

    return (
        <Container className='mt-5'>


            <Row>
                <Col></Col>
                <Col lg={10}>
                    <div className="p-2 text-center" style={{ backgroundColor: "#ffffff", borderRadius: "5px" }}>
                        <span className='fw-semibold' style={{ color: "#605C68", fontSize: "large" }}>
                            Manage Team
                        </span>
                    </div>
                </Col>
                <Col></Col>
            </Row>

            {loading ? (
                <div className="text-center mt-5">
                    <div className="sk-cube-grid">
                        {[...Array(9).keys()].map(i => (
                            <div key={i} className={`sk-cube sk-cube${i + 1}`}></div>
                        ))}
                    </div>
                </div>
            ) : (
                <>
                    <Row className='mt-4'>
                        <Col lg={10} className='mx-auto'>
                            <Row className='d-flex align-items-center mb-3 justify-content-center'>
                                <Col>
                                    <h5 className="fw-semibold">My Projects ({myTeamBody.length})</h5>
                                </Col>
                                <Col lg={4} className='justify-content-end'>
                                    <InputGroup>
                                        <span className="input-group-text bg-white"><i className="fa fa-search"></i></span>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search My Projects..."
                                            value={searchMyProjects}
                                            onChange={(e) => setSearchMyProjects(e.target.value)}
                                        />
                                    </InputGroup>
                                </Col>
                            </Row>

                            <DatatableWrapper
                                body={myTeamBody.filter(item =>
                                    Object.values(item).some(val =>
                                        String(val).toLowerCase().includes(searchMyProjects.toLowerCase())
                                    )
                                )}
                                paginationOptionsProps={{ initialState: { rowsPerPage: 5, options: [5, 10, 15, 20] } }}
                                headers={myTeamHeader}
                            >
                                <Table striped className="data-table">
                                    <TableHeader />
                                    <TableBody />
                                </Table>

                                <Row>
                                    <Col lg={6} xs={12} sm={12} className="d-flex align-items-center justify-content-start">
                                        <span className='me-2 mt-2'>
                                            Show
                                        </span>
                                        <PaginationOptions labels={labels} />
                                        <div className='mt-2 mx-2'>
                                            Records
                                        </div>
                                    </Col>

                                    <Col lg={6} xs={12} sm={12} className='d-flex align-items-center justify-content-end'>
                                        <div className='text-end mb-1 mt-3'>
                                            <Pagination />
                                        </div>
                                    </Col>
                                </Row>
                            </DatatableWrapper>

                        </Col>
                    </Row>

                    {/* ---------------- Actions Buttons --------------- */}
                    {
                        assignProject &&
                        <Row className='mt-4 mb-3'>
                            <Col lg={10} className='mx-auto d-flex justify-content-end gap-3'>
                                <Button onClick={handleOpenAssignModal}>Assign Team</Button>
                            </Col>
                        </Row>
                    }

                    {/* ---------------- My Team Table --------------- */}

                    {
                        assignTeamBody && assignTeamBody?.length > 0 &&
                        <Row className='mt-3'>
                            <Col lg={10} className='mx-auto'>
                                <Row className='d-flex align-items-center mb-3 justify-content-center'>
                                    <Col>
                                        <h5 className="fw-semibold">My Team ({assignTeamBody.length})</h5>
                                    </Col>

                                    <Col lg={4}>
                                        <InputGroup>
                                            <span className="input-group-text bg-white"><i className="fa fa-search"></i></span>
                                            <Form.Control
                                                type="text"
                                                placeholder="Search My Team..."
                                                value={searchMyTeam}
                                                onChange={(e) => setSearchMyTeam(e.target.value)}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>

                                <DatatableWrapper
                                    body={assignTeamBody.filter(item =>
                                        Object.values(item).some(val =>
                                            String(val).toLowerCase().includes(searchMyTeam.toLowerCase())
                                        )
                                    )}
                                    headers={assignTeamHeader}
                                    paginationOptionsProps={{ initialState: { rowsPerPage: 5, options: [5, 10, 15, 20] } }}
                                >
                                    <Table striped className="data-table">
                                        <TableHeader />
                                        <TableBody />
                                    </Table>

                                    <Row>
                                        <Col lg={6} xs={12} sm={12} className="d-flex align-items-center justify-content-start">
                                            <span className='me-2 mt-2'>
                                                Show
                                            </span>
                                            <PaginationOptions labels={labels} />
                                            <div className='mt-2 mx-2'>
                                                Records
                                            </div>
                                        </Col>

                                        <Col lg={6} xs={12} sm={12} className='d-flex align-items-center justify-content-end'>
                                            <div className='text-end mb-1 mt-3'>
                                                <Pagination />
                                            </div>
                                        </Col>
                                    </Row>
                                </DatatableWrapper>
                            </Col>
                        </Row>
                    }

                    {/* ---------------- Assign Team Modal --------------- */}

                    <AssignTeamModal addProject={addProject} showModal={showModal} setShowModal={setShowModal} setReloadComponent={setReloadComponent} reloadComponent={reloadComponent} />

                    {/* ---------------- Add Project Modal --------------- */}

                    <Modal show={showAddProjectModal} selectedProjects={selectedProjects} setSelectedProjects={setSelectedProjects} handleAssignTeam={handleAssignTeam} onHide={handleClose} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Project</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form>

                                <Form.Group className="mb-3">
                                    <Form.Label>Project Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="projectName"
                                        placeholder="Enter project name"
                                        value={projectForm.projectName}
                                        onChange={onChangeForm}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Select Members</Form.Label>
                                    <Form.Select multiple onChange={onMembersSelect}>
                                        <option value="John Doe">John Doe</option>
                                        <option value="Sarah Lee">Sarah Lee</option>
                                        <option value="David Miller">David Miller</option>
                                        <option value="Emma Wilson">Emma Wilson</option>
                                    </Form.Select>
                                </Form.Group>

                            </Form>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                            <Button variant="primary" onClick={handleSaveProject}>Save Project</Button>
                        </Modal.Footer>
                    </Modal>
                </>
            )}
        </Container>
    );
};

export default ManageTeam;
